import { useCallback } from 'react'

type EventType = 'generate_lead'

const useAnalytics = () =>
  useCallback((type: EventType) => window.gtag('event', type), [])

export default useAnalytics
